import React from 'react';
import { Link } from 'react-router-dom';

import GameOfLifeCanvas from './gameOfLife/GameOfLifeCanvas.js';
import ECGSketch from './monitors/ECGSketch.js';
import MAPSketch from './monitors/MAPSketch.js';
import MonitorClock from './monitors/MonitorClock.js';
import PlethSketch from './monitors/PlethSketch.js';
import RespSketch from './monitors/RespSketch.js';
import TemperatureReadout from './monitors/TemperatureReadout.js';

import './style/Home.scss';

const Intro = () => (
  <div className="monitor-header">
    <Link to="/about" className="rounded header-link">
      <div className="flex col" style={{ flex: 1 }}>
        <div className="monitor-identity-name">Anthony Bosshardt, MD</div>
        <div className="monitor-identity-detail">Physician • Software Engineer</div>
      </div>
    </Link>
    <div className="monitor-status">
      <span className="monitor-status-dot" />
      MONITORING
    </div>
    <div className="date text-right">
      <MonitorClock />
    </div>
  </div>
);

const Home = () => (
  <div className="home-monitor">
    <GameOfLifeCanvas />
    <div className="flex col vital-signs-container">
      <Intro />
      <div className="monitor-settings">
        <span>ECG · Lead II</span>
        <span>25 mm/s &nbsp; 10 mm/mV</span>
      </div>
      <ECGSketch />
      <MAPSketch />
      <PlethSketch />
      <RespSketch />
      <div className="monitor-footer">
        <TemperatureReadout />
        <span className="monitor-power">
          <span className="monitor-status-dot" />
          AC POWER
        </span>
      </div>
    </div>
  </div>
);

export default Home;

// convert the excel to json -> upload the json to the app
